module.exports = __webpack_public_path__ + "images/2_old0ffbcef63a31434429b377d823acf9dd.svg";